import { createSlice } from "@reduxjs/toolkit";

import { type UserStateType } from "../interfaces/user";

const initialState: UserStateType = {
  isLoading: false,
  users: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
  },
});

export const { setUserLoading, setUsers } = userSlice.actions;
export default userSlice.reducer;
